import React from "react";

import Image from "../../components/image";
import TickIcon from "../../images/icons/tick-dark.inline.svg";

const ExpeditionContent = ({ content }) => {
  return (
    <div className="flex items-start py-1 gap-2">
      <div className="w-1/12 py-1">
        <TickIcon className="w-3 h-3 stroke-black-lighter dark:stroke-gray-generic" />
      </div>
      <div
        className="text-sm text-black-lighter dark:text-gray-generic text-left w-11/12 font-normal"
        dangerouslySetInnerHTML={{
          __html: content
        }}
      />
    </div>
  );
};

const ExpeditionsCard = ({
  groupExpExpeditionsMainTitle,
  groupExpeditionsMainDescription,
  groupExpeditions
}) => {
  return (
    <>
      <h2
        className="text-3xl text-left py-6 lato-regular-latin"
        dangerouslySetInnerHTML={{ __html: groupExpExpeditionsMainTitle }}
      />

      {groupExpeditionsMainDescription && (
        <div className="flex items-start sm:items-center pb-6">
          <div className="">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1}
              stroke="currentColor"
              className="w-8 h-8 stroke-black-lighter dark:stroke-gray-generic"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75"
              />
            </svg>
          </div>
          <div
            className="text-base text-black-lighter dark:text-gray-generic pl-2"
            dangerouslySetInnerHTML={{
              __html: groupExpeditionsMainDescription
            }}
          />
        </div>
      )}

      {groupExpeditions?.length > 0 &&
        groupExpeditions?.map((expedition, i) => {
          const title = expedition?.groupExpExpeditionsTitle;
          const icon = expedition?.groupExpExpeditionsIcon;
          const iconUrl = expedition?.groupExpExpeditionsIcon?.sourceUrl;
          const image = expedition?.groupExpExpeditionsImage;
          const imageUrl = expedition?.groupExpExpeditionsImage?.sourceUrl;

          return (
            <div className="flex flex-col" key={i}>
              <div className="flex flex-col md:flex-row items-start justify-between py-5 border-b border-gray-light sm:border-b-0">
                <div className="w-full sm:w-2/5 font-bold text-mob sm:text-base pr-6">
                  <div className="flex items-center pb-2">
                    <Image
                      imageClass={"w-10 h-10"}
                      imageAlt={""}
                      image={icon}
                      sourceUrl={iconUrl}
                    />
                    <div
                      className="text-lg text-black-lighter dark:text-white pl-2 font-normal font-alice dark:font-body"
                      dangerouslySetInnerHTML={{
                        __html: title
                      }}
                    />
                  </div>

                  <div className="divide-y width-divider mb-3" />
                  {expedition?.groupExpExpeditionsContent?.map(
                    (expeditionContent, i) => (
                      <ExpeditionContent
                        key={i}
                        content={expeditionContent?.groupExpContent}
                      />
                    )
                  )}
                </div>

                <div className="w-full sm:w-3/5 h-full mt-3 sm:mt-0">
                  {i < 1 && (
                    <div className="p-0 m-0 w-full flex align-middle justify-end h-5">
                      <div className="text-white dark:text-gray-darker uppercase text-[10px] tracking-wider bg-black-lighter dark:bg-white py-1 px-2 flex justify-center items-center">
                        Most Popular
                      </div>
                    </div>
                  )}
                  <Image
                    imageClass={"object-cover rounded-md w-full h-36"}
                    imageAlt={""}
                    image={image}
                    sourceUrl={imageUrl}
                  />
                </div>
              </div>
            </div>
          );
        })}
    </>
  );
};
export default ExpeditionsCard;
